import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString, getOrderDate } from "./fulfillment-group-csv-utils";

export const OrderDateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Order date",
    cell: (row) => formatDateString(getOrderDate(row)?.toISOString() ?? ""),
  };
